import { useState } from "react"
import { BrowserView, MobileView } from "react-device-detect"
import DesktopCategoryFilter from "./DesktopCategoryFilter"
import MobileCategoryFilter from "./MobileCategoryFilter"

function CategoryFilter({ className, categories, onSelectItem }) {
  const [active, setActive] = useState(null)

  const selectItem = (category) => {
    setActive(category)

    if (onSelectItem) {
      onSelectItem(category)
    }
  }

  return (
    <>
      <BrowserView>
        <DesktopCategoryFilter
          className={className}
          primaryCategories={categories.slice(0, 3)}
          secondaryCategories={categories.slice(3, categories.length)}
          categories={categories}
          onSelectItem={selectItem}
          active={active}
        />
      </BrowserView>
      <MobileView>
        <MobileCategoryFilter
          className={className}
          categories={categories}
          onSelectItem={selectItem}
          active={active}
        />
      </MobileView>
    </>
  )
}

export default CategoryFilter
